import Image from "next/image"
// import interviewweb from "../../assets/images/Delhi/UPSC-Personality-test-Web-Banner.jpg";
//  import interviewmob from "../../assets/images/Delhi/UPSC-Personality-test-Mob-Banner.jpg";
import preebookingm from "../../assets/images/Delhi/UPSC-GSPCM-Mob-Banner.jpg";
import preebookingd from "../../assets/images/Delhi/UPSC-GSPCM-Web-Banner.jpg";
import upscachiever from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg";
import upscresult from "../../assets/images/upsc/prestorming/UPSC-Moct-test-Web-Banner-26.jpg";
import upscresult2024 from "../../assets/images/upsc/prestorming/UPSC-Moct-test-Mob-Banner-26.jpg";
import AgricultureWeb from "../../assets/images/Delhi/Agriculture-optional-Delhi-Web-Banner.jpg";
import AgricultureMob from "../../assets/images/Delhi/Agriculture-optional-Delhi-Mobile-Banner.jpg";
import HistoryWeb from "../../assets/images/Delhi/History-optional-Delhi-Web-Banner.jpg";
import HistoryMob from "../../assets/images/Delhi/History-optional-Delhi-Mobile-Banner.jpg";
import PsirWeb from "../../assets/images/Delhi/PSIR-optional-Delhi-Web-Banner.jpg";
import PsirMob from "../../assets/images/Delhi/PSIR-optional-Delhi-Mobile-Banner.jpg";
import downloadicon from "../../assets/images/download.png";
import notification from"../../assets/images/Delhi/notification.gif";
import upsc2702mobile from "../../assets/images/Delhi/CSAT_Mobilebanner.jpg";
import upsc2702web from "../../assets/images/Delhi/CSAT_Web_banner.jpg";
import sectionagriculture from "../../assets/images/Delhi/Forestry-Optional-Delhi-Banner.jpg";
import upscadmissionb from "../../assets/images/Delhi/MOCK-TEST-Web-Banner-Delhi.jpg";
import prebookingb from "../../assets/images/Delhi/UPSC-Admissions-Open-26.jpg";
import sectioncsat from "../../assets/images/Delhi/CSAT-Batch3.jpg";
import sctionmokash from "../../assets/images/Delhi/Moksha-2025-Banner.jpg";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Carousel from 'react-bootstrap/Carousel';
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
import redrightarrow from "../../assets/images/contact/redrightarrow.png";
const Interest = dynamic(() => import("../../components/might-be-interest"));
const Acheiver = dynamic(() => import("../../components/delhi-acheiver/achievers"));
const BranchDelhiAddress = dynamic(() => import("../../components/branch-address/delhi"));
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "./delhi-form";
import Link from "next/link";
import useDownloader from "react-use-downloader";
import youtube_thumnail_1 from "../../assets/images/home/youtube/youtube_thumnail_33.webp";
import youtube_thumnail_2 from "../../assets/images/home/youtube/Youtube-thumbnail_312.jpg";
//import youtube_thumnail_3 from "../../assets/images/home/youtube/Civil-Sabha.png";
import youtube_thumnail_3 from "../../assets/images/home/youtube/Felicitation-programme-2024.jpg";
import Delhiimg from "../../assets/images/Delhi/Delhi-WebPage-Image.jpg";
import NewiconA from "../../assets/images/Delhi/touch.png";
import Newicon from "../../assets/images/header/newanimation.gif";
import Emioption from "../../components/Service/emioption";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import Optionalplus from "../../components/Service/optionalplus";
import Stdtestimonial from "../../components/Delhi-Testimonial/Testimonial";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
import Modal from 'react-bootstrap/Modal';
import Head from "next/head";
const UPSCClassroomOnline = () => {
  
  const [modalOpen, setModalOpen] = useState(false);
  const [videoURL, setVideoURL] = useState("");
  const { download } = useDownloader();

  const [play, setPlay] = useState(false);
  const [play1, setPlay1] = useState(false);
  const [play2, setPlay2] = useState(false);
  const [play3, setPlay3] = useState(false);

  const fileUrl = "/pdf/SIA-Brochure-2025-Delhi.pdf";
  const filename = "SIA-Brochure-2025-Delhi.pdf"

  const feestructure = [ 
    { date: "16.02.2026", cont: "Regular", cont1: "08:00 am to 01:30 pm" },
    { date: "27.04.2026", cont: "Regular", cont1: "08:00 am to 01:30 pm" },
    { date: "12.06.2026", cont: "Regular", cont1: "08:00 am to 01:30 pm" },

    //  { date: "23.06.2025", cont: "Regular", cont1: "Will be update" },
  ]

  const feestructure2 = [
   
    { date: "10.08.2026", cont: "Regular", cont1: "09:00 am to 01:00 pm" },
  
  ]

 const feestructure3 =[
    {date:"27.04.2026",cont:"Weekend",cont1:"Agriculture",cont2:"10:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
     {date:"05.07.2026",cont:"Weekend",cont1:"Public Administration",cont2:"09:00 am to 01:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"PSIR",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
     {date:"10.07.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
     ]
  const banners = [
    {img: upscachiever, alt: "UPSC delhi", link: "/"},
    { img: preebookingd, alt: "UPSC delhi", link: ""},
    // { img: upsc2702web, alt: "UPSC delhi", link: "/delhi"}, 
    { img: upscresult, alt: "UPSC delhi", link: "/all-india-upsc-prelims-mock-test/"},
    // { img: interviewweb, alt: "UPSC delhi", link: "/upsc-interview"},
    { img: AgricultureWeb, alt: "UPSC result", link: "/delhi"},
    { img: HistoryWeb, alt: "History Optional", link: "/delhi"},
    { img: PsirWeb, alt: "PSIR Optional", link: "/delhi"},
  ]

  const mbbanners = [
    { img: preebookingm, alt: "UPSC delhi", link: ""},
    //  { img: upsc2702mobile, alt: "UPSC delhi", link: "/delhi"},
    { img: upscresult2024, alt: "UPSC delhi", link: "/all-india-upsc-prelims-mock-test"},
    // { img: interviewmob, alt: "UPSC delhi", link: "/upsc-interview"},
    { img: AgricultureMob, alt: "UPSC result", link:"/delhi"},
    { img: HistoryMob, alt: "History Optional", link: "/delhi"},
    { img: PsirMob, alt: "PSIR Optional", link: "/delhi"},
    
   
  ]

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Best IAS Academy in Delhi | Shankar IAS Academy",
    "url": "https://www.shankariasacademy.com/delhi/",
    "Image":
    "https://www.shankariasacademy.com/_next/static/media/Result-2022-Web-Banner-2.96c6f4ff.webp",
    "description": "Shankar IAS Academy is the best IAS Academy in Delhi, offering top-notch UPSC training, experienced faculty, and a high success rate in civil services."
  }
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    // Cleanup on component unmount
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);
  return (
    <>
    <Head>
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-2ST7ZJ1RE5"></script>
      <script>
      {
      `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-2ST7ZJ1RE5');
      `
      }
      </script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noodp,noydir" />
        <meta name="robots" content="index,follow" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2026-01-09T04:30:44+00:00" />
        <title>Best IAS Coaching in Delhi | Shankar IAS Academy Karol Bagh</title>
        <meta name="title" content="Best IAS Coaching in Delhi | Shankar IAS Academy Karol Bagh" />
        <meta name="description" content="Shankar IAS Academy offers the best UPSC coaching in Delhi. Join our Karol Bagh center for foundation courses, test series, and interview guidance." />
        <link rel="canonical" href="https://www.shankariasacademy.com/delhi/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Best IAS Coaching in Delhi | Shankar IAS Academy Karol Bag" />
        <meta property="og:description" content="Shankar IAS Academy offers the best UPSC coaching in Delhi. Join our Karol Bagh center for foundation courses, test series, and interview guidance." />
        <meta property="og:url" content="https://www.shankariasacademy.com/delhi/" />
        <meta property="og:site_name" content="Shankar IAS Academy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@shankarias" />
        <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
    </Head>

<Navbar title="upsc" />

<div className="container">
  <div className="row">
    <div className="col pt-3 pt-md-4">
      <div className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}>
          <Link href="/upsc-admission-anna-nagar"><button id={styles.tablinks} className="nav-link tab1 py-2 px-0 me-4 " type="button">Anna Nagar</button></Link>
          <Link href="/adyar"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Adyar</button></Link>
          <Link href="/bengaluru"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Bengaluru</button></Link>
          <Link href="/coimbatore"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Coimbatore</button></Link>
          <Link href="/delhi"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4 active" type="button">Delhi</button></Link>
          <Link href="/hyderabad"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Hyderabad</button></Link>
          <Link href="/thiruvananthapuram"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Thiruvananthapuram</button></Link>
          <Link href="/trichy"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Trichy</button></Link>
          <Link href="/salem"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Salem</button></Link>
          <Link href="/madurai"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Madurai</button></Link>
          <Link href="/upsc-online-class"><button id={styles.tablinks} className="nav-link tab10 py-2 px-0 me-4" type="button">Online Class</button></Link>
          <Link href="/upsc-admission-nri"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">NRI</button></Link>
      </div>
    </div>
  </div>
</div>
         

 <div className="container pb-2">
    <div className="row">
      <div className="col d-none d-md-block">
        <Carousel>
          {banners.map((e, index) =>
            <Carousel.Item key={index}>
             <Link href={e.link} rel="noreferrer">
                <Image
                className="carouselimage w-100 h-100"
                src={e.img}
                alt={e.alt}
                title="Shankar IAS Academy"
                loading="eager"
                placeholder="blur"/>
              </Link>
            </Carousel.Item>
          )}
        </Carousel>
      </div>
    </div>                 
   
    <div className="container pb-2">
        <div className="row">
            <div className="col d-block d-md-none">
                <Carousel>
                    {mbbanners.map((e, index) =>
                      <Carousel.Item key={index}>
                        <Link href={e.link} rel="noreferrer">
                          <Image
                            className="carouselimage"
                            src={e.img}
                            alt={e.alt}
                            title="Shankar IAS Academy"
                            placeholder="blur"
                          /></Link>
                      </Carousel.Item>
                    )}
                </Carousel>
            </div>
        </div>
    </div>
</div> 

<div className="container">
  <div className="row">
    <div className={styles.marqueeWrapper}>
      <div className={styles.marqueeTrack}>
        <div className={styles.marqueeMove}>   
          <div className={styles.marqueeItem}>
            <a href="https://www.shankariasacademy.com/upsc-interview/" target="_blank">
              Civils & Forest Service Interview Guidance 2026 <Image src={notification} width="24" height="24" alt="agriculture" />
            </a>
            <a href="https://www.shankariasacademy.com/delhi" target="_blank">
               UPSC 2026 Admissions Open <Image src={Newicon} width="24" height="24" alt="New_icon" className="img-fluid mx-2" />
            </a>
            <a href="https://www.shankariasacademy.com/upsc-prelims-test-series/" target="_blank">
              UPSC Prelims Test Series - 2026
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


{/* <Classroom_form branchname="Delhi" /> */}
<div className="container">
  <div className={`${styles.coursesimg} mb-2`}>
    <div class="col-12 col-md-6 offset-md-3 mt-4">
      <p className={`${styles.contactheader} text-center`}>Enquiry</p>
      <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
      <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
    </div>
  </div>
</div>

<section className="container pb-4">
  <div className="pt-4">
    <div className="row">                            
        <div className="col-lg-6 col-12 mb-3  d-md-block">
             <a href="/all-india-upsc-prelims-mock-test" > <Image 
              src={upscadmissionb} 
              width="579" height="253" className="img-fluid h-100 w-100" alt="UPSC Personality test 2025" 
            />
            </a>
        </div>

        <div className="col-lg-6 col-12 mb-3  d-md-block">
          <a href="#preebooking" ><Image src={prebookingb} width="579" height="253" className="img-fluid h-100 w-100" alt="prebooking" /> </a>
        </div>
    </div>
    <div className="row">
      {/* <div className="col-lg-6 col-12 mb-3  d-md-block">
            <a href="/forestry-admission" target="_blank"> <Image src={sectionagriculture} width="579" height="253" className="img-fluid h-100 w-100" alt="agriculture" /></a>
          </div>
        
        <div className="col-lg-6 col-12 mb-3  d-md-block">
            <a href="https://www.shankariasacademy.com/upsc-mains-test-series/" target="_blank"><Image src={sctionmokash} width="579" height="253" className="img-fluid h-100 w-100" alt="agriculture" /></a>
          </div> */}
    </div>
  </div>
</section>

<section style={{background: "#F4F6F8 0% 0% no-repeat padding-box",opacity: "1" }}>
  <div className="container pt-4">  
    <div className={`${styles.roadmapContainer} `}>
      <div className="row mb-0">
        <div className=" col-md-6 col-12 pt-2">
            <h1 className={`${styles.sectiontitle}`}>Best IAS Coaching in Delhi | Shankar IAS Academy Karol Bagh</h1>
            <p className={`${styles.acheiverrank}`}><span><Link className={`${styles.program1}`} href="/">Shankar IAS Academy</Link></span>, 20 years of legacy in the UPSC Coaching, proud to claim the title of <b>Best IAS Institute in Delhi</b>, by giving selection in UPSC CSE Examination for continuous years without fail.</p>
            <p className={`${styles.acheiverrank}`}>We became the <b>Best UPSC Coaching in Delhi</b>, by giving our classroom programs with meticulously tailored to address the dynamic nature of the UPSC Civil Service exam.</p>
            <p className={`${styles.acheiverrank}`}>With an expert faculty team, personalized coaching, state-of-the-art classrooms, and infrastructure, we stand as the <b>Best IAS Academy in Delhi</b>. Join us at our Karol Bagh campus, and we'll guide you towards Dholpur House.</p>
        </div>

        <div className=" col-md-6 col-12 pt-2">
          <Image src={Delhiimg} className="img-fluid" alt="Best IAS Coaching in Delhi" title="Best IAS Coaching in Delhi | Shankar IAS Academy Karol Bagh" />
        </div>
      </div>
    </div>

    <div className={`${styles.roadmapContainer} `}>
      <div className="row mb-0">
        <div className="col-md-6 col-12 pt-2">
          <h3 className={`${styles.sectiontitle} mb-2`}>UPSC Preparation</h3>
          <p className={`${styles.delhiacheiver} mb-0`}>Every year around 10 lakh students apply for the UPSC examination. Among these only a few thousand students sail through the prelims and qualify for mains. Finally, only around 1000 candidates become a Civil Servant. The pass percentage of candidates in UPSC Civil Service examination is a meager 0.2%.</p>
          <p className={`${styles.delhiacheiver} pt-3`}>Joining the best IAS Academy, can save your precious time, as the content given will be refined to meet the demands of the UPSC. The Courses we offer in Shankar IAS Academy are performance-driven and <b>Best IAS Coaching in Delhi.</b></p>
        </div>
        <div className="col-md-6 col-12 pt-2">
          <h3 className={`${styles.sectiontitle} mb-2`}>Courses Offered</h3>
          <p className={`${styles.delhiacheiver}`}>We offer a diverse array of courses, ranging from the GS Foundation Course for aspiring Civil Servants to Personality Test Coaching for seasoned aspirants on the cusp of their Civil Service journey. Our courses are scientifically designed and results-oriented, including:</p>
          <ul>
            <li className={`${styles.delhiacheiver}`}><b>General Studies</b> - 1 Year Foundation Course for Prelims and Mains</li>
            <li className={`${styles.delhiacheiver}`}><b>General Studies</b> - 2 Years Foundation Course for Prelims and Mains <span><Link className={`${styles.program1}`} href="/two-year-upsc-program">(SADHANA)</Link></span></li>
            <li className={`${styles.delhiacheiver}`}><b>Current Affairs Program</b> - Classes + Exam <b>(CHAKRA)</b></li>
            <li className={`${styles.delhiacheiver}`}><b>Optional Subject Courses</b></li>
            <li className={`${styles.delhiacheiver}`}><b>Prelims Test Series</b> - Weekly <span><Link className={`${styles.program1}`} href="/upsc-prestorming-prelims-test-series">(UPSC Prestorming)</Link></span></li>
            <li className={`${styles.delhiacheiver}`}><b>Prelims Test Series</b> - Daily <span><Link className={`${styles.program1}`} href="/upsc-prefit-prelims-test-series">(UPSC Prefit Test)</Link></span></li>
            <li className={`${styles.delhiacheiver}`}><b>Mains Test Series</b> - <span><Link className={`${styles.program1}`} href="/upsc-mains-test-series">MOKSHA</Link></span></li>
            <li className={`${styles.delhiacheiver}`}><b>Indian Forest Service</b> - Mains Coaching</li>
            <li className={`${styles.delhiacheiver}`}><b>Personality Test Coaching</b> <span><Link className={`${styles.program1}`} href="/upsc-interview">(CIVILIASATION)</Link></span></li>
          </ul>
          <p className={`${styles.acheiverrank}`}>For further details such as course schedules, durations, and fee structures, feel free to <span><Link className={`${styles.program1}`} href="/contact-us">Contact us</Link></span>.</p>  
        </div>
      </div>
    </div>

    <div className="row pt-3">
      <div className=" col-md-6">
         <h2 className={`${styles.sectiontitle} mb-2`}><span style={{color:"#fd0909"}}>W</span>hy Choose <span style={{color:"#fd0909"}}>S</span>hankar IAS Academy in <span style={{color:"#fd0909"}}>D</span>elhi?</h2>
         <p className={`${styles.acheiverrank}`}>There are 100+ UPSC Coaching Centre in Delhi. But why should you choose us?</p>
         <h2 className={`${styles.sectionsubtitle} mb-2`}>The Key differentiators are,</h2>               
         <h3 className={`${styles.acheiverrank}`}><b> <i className="bi bi-check-circle-fill text-success me-2"></i>In-depth Syllabus Coverage</b></h3>                 
         <p className={`${styles.acheiverrank}`}>Our 200+ classes extensively cover the entire UPSC Prelims and Mains syllabus, with each class lasting 150 minutes.</p>
         <h3 className={`${styles.acheiverrank}`}> <i className="bi bi-check-circle-fill text-success me-2"></i><b>Experienced Faculty Team</b></h3>
         <p className={`${styles.acheiverrank}`}>Our faculty members are the best in Delhi and boast over 10+ years of experience in UPSC and have first-hand experience in clearing various stages of the UPSC Examination.</p>
         <h3 className={`${styles.acheiverrank}`}> <i className="bi bi-check-circle-fill text-success me-2"></i><b>Frequent Interactions with Achievers</b></h3>
         <p className={`${styles.acheiverrank}`}>We facilitate regular seminars and interactive sessions with successful Civil Servants, offering valuable insights and inspiration.</p>
         <h3 className={`${styles.acheiverrank}`}> <i className="bi bi-check-circle-fill text-success me-2"></i><b>Personalized Mentoring</b></h3>
         <p className={`${styles.acheiverrank}`}>Our scientifically designed mentorship program is the best in Delhi, and ensuring every student receives consistent support and monitoring throughout their preparation journey.</p>
         <h3 className={`${styles.acheiverrank}`}> <i className="bi bi-check-circle-fill text-success me-2"></i><b>AI-powered Test Series</b></h3>
         <p className={`${styles.acheiverrank}`}>To assess students' knowledge and provide insights into the nature and depth of the UPSC exam, we offer an AI-powered best UPSC test series comprising 25 tests for Prelims and 10 for Mains.</p>
         <h3 className={`${styles.acheiverrank}`}> <i className="bi bi-check-circle-fill text-success me-2"></i><b>Interview Guidance</b></h3>
         <p className={`${styles.acheiverrank}`}>Our free Interview Guidance program includes DAF analysis, perspectives on current issues, and group discussions, preparing students for the final stage of the Civil Service journey</p>
         <p className={`${styles.acheiverrank}`}>Our commitment to deliver the best IAS coaching for Aspirants in Delhi, coupled with these factors, makes Shankar IAS Academy the top choice <b>IAS Coaching Centre in Delhi.</b> </p>
      </div>

      <div className="col-md-6">  
        <h3 className={`${styles.sectiontitle} mb-2`}><span style={{color:"#fd0909"}}>A</span>chievements</h3>
        <p className={`${styles.acheiverrank}`}>With <b>2700+</b> successful results in the prestigious UPSC examination, our track record speaks for itself. In the <b>2024 Civil Services Examination 25 out of the Top 100 candidates</b> hailed from our institute. Our consistent performance is highlighted by the following yearly selections:</p> 
        <ul className={`${styles.tickList}`}>
          <li className={`${styles.acheiverresult}`}><b>2024</b> - 238 Selections out of 1009 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2023</b> - 273 Selections out of 1016 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2022</b> - 336 Selections out of 1022 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2021</b> - 260 Selections out of 712 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2020</b> - 363 Selections out of 836 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2019</b> - 201 Selections out of 927 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2018</b> - 126 Selections out of 782 vacancies</li>
        </ul>
        <p className={`${styles.acheiverrank}`}>Furthermore, our outstanding record extends to Indian Forest Service Coaching, with 8 out of the Top 10 achievers in the 2022 IFoS exam and 101 successful candidates hailing from Shankar IAS Academy.</p>
        <ul className={`${styles.tickList}`}>
          <li className={`${styles.acheiverresult}`}><b>2024</b> - 78 selections out of 143 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2023</b> - 102 selections out of 147 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2022</b> - 101 selections out of 147 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2021</b> - 79 selections out of 108 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2020</b> - 50 selections out of 90 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2019</b> - 46 selections out of 88 vacancies</li>
          <li className={`${styles.acheiverresult}`}><b>2018</b> - 34 selections out of 89 vacancies</li>
        </ul>
          <p className={`${styles.acheiverrank}`}>This impeccable track record in UPSC Civil Service and Indian Forest Service Examinations establishes us as the <b>best IAS coaching institute in Delhi</b>, making Shankar IAS Academy - the <b>top IAS academy in Delhi.</b></p>
      </div>
    </div>
  </div>
</section>

<section className={`${styles.bestbg1}`} id="preebooking">
  <div className="container">  
      <div className="row g-4 mt-2">
        <div className="col-12 col-md-6 col-lg-12">
          <div className="card shadow-sm p-4">
            <h3 className={`${styles.titlec}`}> Pre Booking Open</h3> 
            <p>
            For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>88991 80180</span> 
            </p>
            <div className={`${styles.brochure} justify-content-center`}>
                <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-delhi-admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                  <button className={`${styles.normalbutton1} btn btn-danger`}>
                    <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                  </button>
                </a>
            </div> 
          </div>
        </div>   
      </div>
  </div>
</section>

<section>
  <div className="container pt-4 pt-lg-5">
    <div className="row">

        {/* <div className={`${styles.brochure}`}>
      <h2 className={`${styles.sectiontitle} pt-3`}>Course and Fees</h2>
      <button className={`${styles.normalbutton2} ${styles.brochurebtn}`} onClick={() => download(fileUrl, filename)}>
        <Image src={downloadicon} alt="download icon" />
        <p className={`${styles.brochuretxt}`}>UPSC GSPCM 2025 (Brochure)</p>
      </button>
      </div> */}

      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
        <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>General Studies</p>
            <p className={`${styles.sectionsubtitle} mx-3`}>(Preliminary Cum Mains)</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>1,00,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
         
      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
              <tr>
               {/* <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>(Video Conference)</b></td>  */}
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
      </div>
    

      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
         <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>CSAT</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>20,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=Delhi&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>
          

      <div className="pt-3">       
        <div className="row mx-auto">
          <div className="col ps-0">
          <table className="table ">
            <tbody>
            {feestructure2.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
              </tr>
              ))}
            <tr>
             {/* <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>(Video Conference)</b></td>  */}
            </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
      </div>


      <div className="col-xl-4 col-lg-6 mb-3 mb-md-4 col-12">
           <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-8`} >
            <p className={`${styles.sectionsubtitle} mb-0 mx-3`}>Optional</p>
            <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>40,000</span></span>
          </div>

          <div className={`${styles.facultyborder3} col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=Delhi&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>


        <div className="pt-3" id="paymentsection">       
         <div className="row mx-auto">
          <div className="col ps-0 ps-xl-0 p-xl-0">
            <div className="table-responsive text-nowrap">
          <table className="table ">
            <tbody>
            {feestructure3.map((item,index)=>(
              <tr key={index}>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
              </tr>
              ))}
              <tr>
               <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>Forestry and Geology - After Prelims Result</b></td>
              </tr>
              <tr>
           {/* <td colSpan="4" className={`${styles.classacheiverrank} mb-0`}><b>(Video Conference)</b></td>  */}
              </tr>
            </tbody>
          </table>
          </div>
          </div>   
        </div>
      </div>
    </div>

    </div>     
    <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>
       <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
          <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
       </div>

       <div className="col-xl-3 col-lg-4 col-md-6 col-12">
         <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle} `}><b>₹</b>1,60,000*</span><span>(inclusive of tax)</span></span>
       </div>

      <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2  text-right">
         <Emioption />   
      </div>

      <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
        <a href="https://admissionsv1.shankariasacademy.com/?center=Delhi&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
       </div>

       <p className={`${styles.aboutparagraph1}  p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>
    </div>
  </div> 
</section>

<section className={`${styles.prestorming}}`}>  
  <div className="col-12 mt-2 p-2 d-flex flex-column align-items-center">
    <h4 className="fw-bold">UPSC Prelims Test Series 2026</h4>
    <Link href="/upsc-prestorming-prelims-test-series" target="plank">
      <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-3`}>
        Click Here
      </button>
    </Link>
  </div>
</section>

<section className="pb-3">
  <div className="container">
    <Modal show={modalOpen}
      onHide={() => {
        setModalOpen(false);
        setVideoURL("");
      }}
      centered
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">CSAT Course Preview  <i className="bi bi-youtube" style={{ fontSize: "1.5rem", color: "red" }}></i></h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            setModalOpen(false);
            setVideoURL(""); // stop video
          }}
        ></button>
      </div>

      <Modal.Body className="p-0">
        <iframe
          width="100%"
          height="420"
          src={videoURL}
          title="CSAT Course Preview"
          frameBorder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="rounded-bottom-3"
        ></iframe>
      </Modal.Body>
    </Modal>

    <div className="container">
      <div className="py-4">
        <div className="row">
           <div className="col-lg-5 offset-lg-1 col-12 "> 
              <div className={`${styles.founderbg} text-center`}></div> 
           </div>

            <div className="col-lg-6 col-12"> 
              <h2 className={`${styles.foundertitle} mb-0`}>Mr.SHANKAR DEVARAJAN <br/></h2>
              <p className={`${styles.foundertitle1} `}>(Founder)</p>
              <h3
                className={`${styles.sectiontitle}`}
                id={styles.aboucontentborder}
              >
                Vision
              </h3>

              <p className={`${styles.acheiverranks} `}>
                To become a renowned institution producing eminent and
                responsible civil servants for the society. To give hope and
                opportunity to aspirants from various social-economic
                backgrounds to realize their dream of becoming civil servants.
              </p>

              <h3 className={`${styles.sectiontitle} pt-0`} id={styles.aboucontentborder}>
                Mission
              </h3>

              <p className={`${styles.acheiverranks} `}>
                To provide meticulous and focused training to the aspirants to
                succeed in the Civil Services examination.
              </p>
              <p className={`${styles.acheiverranks} `}>
                To create an environment where the students have access to all
                that is required to prepare for the civil services examination
                effectively, efficiently and enthusiastically by ensuring them
                with excellent coaching and finest study materials.
              </p>
            </div>
        </div>

        <div className="row">
          <div className="col-lg-6 col-12"> 
            <h2 className={`${styles.foundertitle} mb-0`}>Dr.S.D.Vaishnavi<br/></h2>
            <p className={`${styles.foundertitle1} `}>(Director)</p>
            <p className={`${styles.acheiverranks} `}>
              Behind every successful individual, there is often a strong support system, and in the case of this institute and its founder, Dr. Vaishnavi S. D. plays a pivotal role. As both an academician and co-founder, her contributions have been essential to the institute's incredible journey. With a PhD in Health Economics from IIT Madras and a background from TNAU, she is a sought-after columnist in leading economics publications. 
            </p>
            <p className={`${styles.acheiverranks} `}>
              For students from non-economics backgrounds, who often find it challenging to grasp fundamental concepts, her classes provide clear insights and a deep understanding of core topics. Dr. Vaishnavi embodies the qualities of a well-educated and poised individual, whose optimism and grace inspire those around her. She will also be instrumental in shaping the future of UPSC aspirants.
            </p>
          </div> 

            <div className="offset-lg-2 col-lg-4  col-12 pt-4"> 
              <div className={`${styles.founderbg1} text-center`}></div> 
            </div>
        </div>

        <div className="row pt-4">
          <div className="offset-lg-1 col-lg-5  col-12 pt-4"> 
            <div className={`${styles.founderbg2} text-center`}></div> 
          </div>
          <div className="col-lg-6 col-12"> 
            <h2 className={`${styles.foundertitle} pt-4`}>Dr.S.R.Deenadayalan<br/></h2>
            <p className={`${styles.foundertitle1} `}>(Managing Partner )</p>
            <p className={`${styles.acheiverranks} `}>
              Mr.S.R.Deenadayalan father of Mrs.Vaishnavi has been actively participating as managing partner of shankar IAS Academy for the past 10 years. He has vast experience in managing the bookstore of the academy called Bookmark. His knowledge and guidance had been a great help for shaping up the administration of the academy.
            </p>
          </div>       
        </div>
      </div>
    </div>
    <Stdtestimonial/>  
  </div>
</section>
<section>  
 

  <div className="container mb-2 mb-xl-5">
    <div className="row">
      <div className="text-center">
      <h3 className={`${styles.sectiontitle} mb-0 text-center`}>Testimonials</h3>
      <p className={`${styles.sectionsubtitle} text-center`}>
        Hear it from our Achievers
      </p>
    </div>
        <div className="col-12 col-lg-6 my-md-3 px-xl-3">
          {
            play2 ?
              (<iframe src={"https://www.youtube.com/embed/Xwj4MXW1REw?si=XzLmpvMcARGUq-Bu" } className="w-100 h-100  mb-md-3" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
              :
              (<Image src={youtube_thumnail_3} style={{ cursor: 'pointer' }} onClick={() => setPlay2(true)} className="img-fluid h-100 w-100  mb-md-3"
                id="homeyoutube" alt="youtube thumbnail"></Image>)
          }
          <div className="d-none d-md-block">
                <Link
                href="https://www.iasparliament.com/UPSC-IAS-daily-current-videos"
                target="_blank"
                className={`${styles.acheiverrank, styles.courseknowmore} float-end`}
              >
              </Link>
          </div>
        </div>

        <div className="col-12 col-lg-6 pt-3 pt-md-0 my-md-3 px-xl-3">
          {
            play3 ?
              (<iframe src={"https://www.youtube.com/embed/QEouXid_hQ0?si=VoLJhB32F87KdH60"} className="w-100 h-100" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
              :
              (<Image src={youtube_thumnail_2} style={{ cursor: 'pointer' }} onClick={() => setPlay3(true)} className="img-fluid h-100 w-100"
                id="homeyoutube" alt="youtube thumbnail"></Image>)
          }
        </div>
    </div>
  </div>
</section>

<Program_Features branchname="Delhi" />
      
    {/* <div className={`${styles.sadhana} `}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 text-white mt-2 p-2 ">UPSC GS-Mains Test Series 2025 (Moksha)<br />
            <a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a>
          </div>
    
        <div className="col-12 col-md-6 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
            <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
              <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
            </button>
        </div>
        </div>
      </div>
    </div> */}

  {/* Our Acheivers */}

  <div className="container">
    <div className="row">
      <div className="col pt-4 pt-md-5 text-center">
          <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
          <p className={`${styles.sectionsubtitle}`}>
            Rank Holders from our academy
          </p>
      </div>
    </div>
  </div>

  <Acheiver />

  <section id="toppers">
      <div className="container">
        <div className="row">
          <div className="  col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
          <Optionalplus /> 
          </div>
        </div>
      </div>
  </section>

  {/* <div className="ps-0 pe-0">
    <div className="container mb-2 mb-xl-5">
      <div className="row">
        <div className="col-12 col-lg-6 my-md-3 px-xl-3">
          {
            play ?
              (<iframe src={"https://www.youtube.com/embed/occDdTp0Y3Q?autoplay=1"} className="w-100 h-100  mb-md-3" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
              :
              (<Image src={youtube_thumnail_1} style={{ cursor: 'pointer' }} onClick={() => setPlay(true)} className="img-fluid h-100 w-100  mb-md-3"
                id="homeyoutube" alt="youtube thumbnail"></Image>)
          }
          <div className="d-none d-md-block"><Link
            href="https://www.shankariasparliament.com/upsc-current-affairs-videos"
            target="_blank"
            className={`${styles.curntbutton}  ps-3   float-end`}
          >
            All Current Affairs  <Image src={redrightarrow}  alt="arrow icon" title="Link" />
          </Link></div>
        </div>
        <div className="col-12 col-lg-6 pt-3 pt-md-0 my-md-3 px-xl-3">
          {
            play1 ?
              (<iframe src={"https://www.youtube.com/embed/QEouXid_hQ0?si=VoLJhB32F87KdH60"} className="w-100 h-100" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
              :
              (<Image src={youtube_thumnail_2} style={{ cursor: 'pointer' }} onClick={() => setPlay1(true)} className="img-fluid h-100 w-100"
                id="homeyoutube" alt="youtube thumbnail"></Image>)
          }
        </div>
      </div>

      <div className="pt-3 d-block d-md-none">
        <Link href="https://www.shankariasparliament.com/upsc-current-affairs-videos" target="_blank" className={`${styles.curntbutton}`} >
        All Current Affairs
      </Link>
      </div>
    </div>
  </div> */}

<BranchDelhiAddress />
<Interest />
<Footer />

</>
  
)

}

export default UPSCClassroomOnline;
